import { Schema } from "@effect/schema";
import * as t from "io-ts";
import { Percent } from "./percent";

/**
 * @deprecated use `PositionType` instead
 */
export const PositionTypeLegacy = t.union([
  t.literal("collateral"),
  t.literal("protected"),
  t.literal("debt"),
]);

export type PositionTypeLegacy = t.TypeOf<typeof PositionTypeLegacy>;
export type EncodedPositionTypeLegacy = t.OutputOf<typeof PositionTypeLegacy>;

export const PositionType = Schema.Literal(
  "collateral",
  "protected",
  "debt"
).annotations({ identifier: "PositionType" });

export type PositionType = typeof PositionType.Type;
export const positionTypes = PositionType.literals;
export const isPositionType = Schema.is(PositionType);

/**
 * @deprecated
 */
export type PointsInfo = typeof PointsInfo.Type;
export type PointsInfoEncoded = typeof PointsInfo.Encoded;

/**
 * @deprecated
 */
export const PointsInfo = Schema.Struct({
  type: PositionType,
  label: Schema.String,
}).annotations({ identifier: "PointsInfo" });

export type PositionReward = typeof PositionReward.Type;
export type PositionRewardEncoded = typeof PositionReward.Encoded;

export const PositionReward = Schema.Struct({
  apr: Percent,
  rewardTokenSymbol: Schema.String,
  isSuperFest: Schema.Boolean,
}).annotations({ identifier: "PositionReward" });
